export default __webpack_public_path__ + "static/media/teal-wave.72c9c136.svg";